import { render, staticRenderFns } from "./AddClientAgency.vue?vue&type=template&id=4da1c882&"
import script from "./AddClientAgency.vue?vue&type=script&lang=js&"
export * from "./AddClientAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports